import useSWR from 'swr';
import { FetchResult, Task } from '../entities';

type Result = FetchResult & { tasks: Task[] };

export function useUserTasks(id?: number): Result {
  const { data, error, mutate } = useSWR(id ? `/tasks/${id}/user` : null);

  return {
    tasks: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
